import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import styled from "styled-components";
import { Translate } from "react-redux-i18n";
import AddAddressModal from "../../Components/Modals/AddressModal";
import { updateAddAddressModalState, setAddAddressModalData } from "../../Store/Modals/Actions";

// region Style
const H5 = styled.h5`
    display: inline;
`;

const Actions = styled.div`
    display: inline;
    float: right;
`;

const Action = styled.span`
    ${Actions} &:first-of-type {
        margin-right: 10px;
    }
`;

const AddressP = styled.p`
    margin-bottom: 0;
`;

const Button = styled.button`
    width: 100%;
`;
// endregion

function CustomerAddresses(props) {
    const { userInfo: { addresses }, updateAddAddressModalState, setAddAddressModalData } = props;

    function renderAddresses() {
        return _.map(addresses, a =>
            <div key={a.id} className="boxed boxed--border bg--secondary">
                <H5>{a.firstName} {a.lastName}</H5>
                <Actions className="actions">
                    <Action className="action" onClick={() => onAddressEdit(a)}><Translate value="misc.edit" /></Action>
                    <Action className="action"><Translate value="misc.delete" /></Action>
                </Actions>
                <hr/>
                <div className="row">
                    <div className="col-md-12">
                        <AddressP>
                            <strong>{a.firstName} {a.lastName}</strong>
                        </AddressP>
                        <AddressP>
                            <Translate value="account.email" />: {a.email}
                        </AddressP>
                        <AddressP>
                            <Translate value="account.phoneNumber" />: {a.phoneNumber}
                        </AddressP>
                        <AddressP>
                            {a.company}
                        </AddressP>
                        <AddressP>
                            {a.address1}
                        </AddressP>
                        <AddressP>
                            {a.city}, {a.stateProvinceName} {a.zipPostalCode}
                        </AddressP>
                        <AddressP>
                            {a.countryName}
                        </AddressP>
                    </div>
                </div>
            </div>
        );
    }

    function onAddressEdit(address) {
        setAddAddressModalData(address);
        updateAddAddressModalState(true);
    }

    return (
        <div id="account-billing" className="account-tab">
            <h4><Translate value="profile.addresses.title" /></h4>

            <div className="row" style={{ marginBottom: 20 }}>
                <div className="col-lg-4 col-md-5">
                    <Button type="button" className="btn btn--primary type--uppercase" onClick={() => updateAddAddressModalState(true)}><Translate value="address.add" /></Button>
                </div>
            </div>

            {renderAddresses()}

            <div className="row">
                <div className="col-lg-4 col-md-5">
                    <Button type="button" className="btn btn--primary type--uppercase" onClick={() => updateAddAddressModalState(true)}><Translate value="address.add" /></Button>
                </div>
            </div>

            <AddAddressModal/>
        </div>
    );
}

CustomerAddresses.propTypes = {
    updateAddAddressModalState: PropTypes.func,
    setAddAddressModalData: PropTypes.func,
    i18n: PropTypes.object,
    config: PropTypes.object,
    userInfo: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAddAddressModalState,
        setAddAddressModalData
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAddresses);
